import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { isTouchDevice } from 'fg-frontend/plugins/utils';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  HEADER_OVERLAY: '[data-fragment="Header.overlay"]',
  MEGA_MENU_BURGER_TOGGLE: '[data-fragment="Header.megaMenuBurgerToggle"]',
  MEGA_MENU_NAV: '[data-fragment="Header.megaMenuNav"]',
  MEGA_MENU_RWD_TOGGLE: '[data-fragment="Header.megaMenuRWDToggle"]',
  MEGA_MENU_TOGGLES: '[data-fragment="Header.megaMenuToggle"]',
};

class Header extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      overlayVisible: false,
      menuRwdToggleActive: false,
      megaMenuVisible: false,
    };
    this.handleToggleMenu = this.handleToggleMenu.bind(this);
    this.handleToggleRWDMenu = this.handleToggleRWDMenu.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.initialiseOverEvents = this.initialiseOverEvents.bind(this);
  }

  didMount() {
    this.body = document.body;
    this.megaMenuToggles = this.element.querySelectorAll(fragments.MEGA_MENU_TOGGLES);
    this.megaMenuNav = this.element.querySelector(fragments.MEGA_MENU_NAV);
    this.megaMenuBurgerToggle = this.element.querySelector(fragments.MEGA_MENU_BURGER_TOGGLE);
    this.megaMenuRWDToggle = this.element.querySelectorAll(fragments.MEGA_MENU_RWD_TOGGLE);
    this.overlay = document.querySelector('.overlay');
    this.megamenuBreakpoint = 992;

    // Distribute mouse click events
    this.megaMenuBurgerToggle.addEventListener('click', this.handleToggleMenu);
    this.megaMenuRWDToggle.forEach((toggle) => {
      toggle.addEventListener('click', this.handleToggleRWDMenu);
    });

    // Distribute mouse over events
    this.initialiseOverEvents();
    window.addEventListener('resize', this.initialiseOverEvents);
  }

  initialiseOverEvents() {
    if (!isTouchDevice() && (window.innerWidth >= this.megamenuBreakpoint)) {
      this.megaMenuToggles.forEach((toggle) => {
        if (toggle.dataset.id !== 'HASICOVO_ONLINE.p.o-nas' && toggle.dataset.id !== 'HASICOVO_ONLINE.p.kontakt' && toggle.dataset.id !== 'HASICOVO_ONLINE.p.vernostni-klub') {
          toggle.addEventListener('mouseenter', this.handleMouseEnter);
          toggle.addEventListener('mouseleave', this.handleMouseLeave);
        }
      });
    } else {
      this.megaMenuToggles.forEach((toggle) => {
        if (toggle.dataset.id !== 'HASICOVO_ONLINE.p.o-nas' && toggle.dataset.id !== 'HASICOVO_ONLINE.p.kontakt' && toggle.dataset.id !== 'HASICOVO_ONLINE.p.vernostni-klub') {
          toggle.removeEventListener('mouseenter', this.handleMouseEnter);
          toggle.removeEventListener('mouseleave', this.handleMouseLeave);
        }
      });
    }
  }

  // open submenus in RWD
  handleToggleRWDMenu(e) {
    const toggleElement = event.target;
    toggleElement.classList.toggle('active');
    toggleElement.nextElementSibling.classList.toggle('active');
  }

  handleToggleMenu() {
    this.setState({
      menuRwdToggleActive: !this.state.menuRwdToggleActive, // toggles main menu visibility RWD
      overlayVisible: !this.state.overlayVisible, // toggles main menu visibility RWD
    });
  }

  handleMouseEnter(event) {
    this.setState({ overlayVisible: true });
    const toggleElement = event.target;
    toggleElement.classList.add('active'); // Add the "active" class on hover
  }

  handleMouseLeave(event) {
    this.setState({ overlayVisible: false });
    const toggleElement = event.target;
    toggleElement.classList.remove('active'); // Remove the "active" class when mouse leaves
  }
  update() {
    const {
      overlayVisible,
      menuRwdToggleActive,
    } = this.state;

    classNames(this.megaMenuBurgerToggle.firstElementChild, { active: menuRwdToggleActive });
    classNames(this.megaMenuNav, { 'header__nav--active': menuRwdToggleActive });
    classNames(this.overlay, { active: menuRwdToggleActive });
    classNames(this.overlay, { active: overlayVisible });
    classNames(this.body, { 'overlay--visible': overlayVisible });
  }
}

export default Header;



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/components/Header.js